import { inject, Injectable } from '@angular/core';
import { InvitationTokenApi } from './invitation-token.api';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

export interface InvitationTokenResponse {
  id: string;
  value: string;
}

@Injectable({
  providedIn: 'root',
})
export class InvitationTokenService {
  private readonly api = inject(InvitationTokenApi);

  public createToken(drawId: string, registrationId: string): Observable<InvitationTokenResponse> {
    return this.api.createToken(drawId, registrationId);
  }

  public redeemToken(drawId: string, value: string): Observable<HttpResponse<void>> {
    return this.api.redeemToken(drawId, value);
  }

  public answerOnMembershipRequest(drawId: string, tokenId: string, choice: boolean): Observable<HttpResponse<void>> {
    return this.api.answerOnMembershipRequest(drawId, tokenId, choice);
  }
}
